<template>
    <div class="knowledge-list-content">
        <KnowledgePublicTable :directoryInfo="directoryInfo"
                     @onDetailShow="$emit('onDetailShow', $event)"></KnowledgePublicTable>
    </div>
</template>

<script>
import KnowledgePublicTable from './KnowledgePublicTable.vue';
export default {
    name: 'knowledge-list-content',
    components: {
        KnowledgePublicTable
    },
    props: {
        directoryInfo: {
            type: Object,
            default: () => {
                return {};
            }
        }
    }
};
</script>

<style scoped lang="scss">
.knowledge-list-content {
    width: 100%;
    height: 100%;
    padding: 0 0 0 20px;
    overflow: hidden;
    background: var(--knowledge-right-bg);
}
</style>
